var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{staticClass:"icon ais-SearchBox-icon"},[_c('use',{attrs:{"xlink:href":"#geosearch-search"}})]),_vm._v(" "),_c('input',{ref:"autocomplete",staticClass:"ais-SearchBox-input",attrs:{"type":"text","placeholder":"Search by suburb"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }